import Rider from '../../../../fields/rider';
import Button from '@mui/material/Button';
import React from 'react';
import API from '../../../../create/api';
import { toastr } from 'react-redux-toastr';
import * as helper from '../../../../../helper/index';

interface SetRiderProps {
  loading: boolean;
  refreshParcel: any;
  parcels: Array<{
    id: number;
    addToBalance: boolean;
    returnToMerchant: boolean;
    status: string;
  }>;
}

export default function SetRider({ loading, parcels, refreshParcel }: SetRiderProps) {
  const [editRider, setEditRider]: any = React.useState(null);
  async function updateCheckboxRider() {
    const { label: RiderName, value: RiderID } = editRider;

    for (let i = 0; i < parcels.length; i++) {
      const { id } = parcels[i];
      if (RiderID) {
        await API.update(`${process.env.REACT_APP_API_SERVER}/parcels`, id, { rider: RiderID })
          .then((res) => {
            toastr.success('Parcel Updated', `Parcel ID: ${id} Rider to ${RiderName} updated`);
          })
          .catch((error) => {
            helper.axiosErrorHandling(error);
          });
      }
    }

    refreshParcel();
  }

  return (
    <>
      <Rider disabled={loading} onChange={(cp: any) => setEditRider(cp ?? null)} />
      <Button
        color="primary"
        onClick={async () => {
          await updateCheckboxRider();
        }}
        variant="contained"
        size="small"
        disabled={loading ?? !editRider?.value}
      >
        Set Rider
      </Button>
    </>
  );
}
